import { render, staticRenderFns } from "./TrialScreen.vue?vue&type=template&id=1340c30f&scoped=true&"
import script from "./TrialScreen.vue?vue&type=script&lang=js&"
export * from "./TrialScreen.vue?vue&type=script&lang=js&"
import style0 from "./TrialScreen.vue?vue&type=style&index=0&id=1340c30f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1340c30f",
  null
  
)

export default component.exports